import type { StayPlanContract } from "@/hooks/useStayPlanContracts";
import type { DateRange } from "@/lib/daycare-hotel/stayPlans";

export type PlanHeaderPeriod =
  | { kind: "range"; start: string; end: string }
  | { kind: "startsOn"; start: string };

/**
 * A data do cabeçalho do card. No recorrente é o ciclo corrente; no pacote é só
 * a data de início, porque o saldo não expira — o vencimento da cobrança mora
 * no bloco de pagamento, não aqui, para não ser lido como validade das diárias.
 */
export function resolvePlanHeaderPeriod(
  contract: Pick<StayPlanContract, "startsOn">,
  cycle: DateRange | null,
): PlanHeaderPeriod {
  if (cycle) return { kind: "range", start: cycle.start, end: cycle.end };
  return { kind: "startsOn", start: contract.startsOn };
}
